// eslint-disable-next-line no-shadow
export enum CustomerTypes {
  BUSINESSES = 1,
  GOVERNMENTS = 2,
  CUSTOMERS = 3,
  OTHER = 4,
}
